import { formatMoney } from '@/entities/invoice';
import type { ReportEnclosedInvoice } from '@/entities/report';

import { reportCopy } from './copy';

/**
 * Eén zin over de factuur na versturen: welke er meeging en wat versturen ermee deed
 * (gemaakt, definitief gemaakt, of zoals ze was). Ging er geen mee terwijl dat wel was
 * gevraagd, dan staat dat er ook; was er niet om gevraagd, dan zegt de zin niets.
 */
export function invoiceResultLine(
    invoice: ReportEnclosedInvoice | null,
    requested: boolean,
): string | null {
    if (invoice === null) {
        return requested ? reportCopy.invoice.resultMissing : null;
    }

    const total = formatMoney(invoice.total);

    if (invoice.drafted) {
        return reportCopy.invoice.resultDrafted(invoice.number, total);
    }

    return invoice.issued
        ? reportCopy.invoice.resultIssued(invoice.number, total)
        : reportCopy.invoice.resultIncluded(invoice.number, total);
}
